import STATUS from '@common/constants/reducer_statuses'

export const selectNotificationsSlice = state => state.notifications

export const selectRecentNotificationsSlice = state => selectNotificationsSlice(state)?.notificationsRecent

export const selectRecentNotificationsData = state => selectNotificationsSlice(state)?.notificationsRecent?.data
export const selectRecentNotificationsLoading = state =>
  selectNotificationsSlice(state)?.notificationsRecent?.status === STATUS.LOADING
export const selectRecentNotificationsError = state => selectNotificationsSlice(state)?.notificationsRecent?.error
